/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Carregando...',
	'dlg_close': 'Fechar',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Cancelar',
	'dlg_back': 'Voltar',
	'dlg_done': 'Pronto',
	'dlg_save': 'Salvar',

	// Slider
	'sliderRegionLabel': 'Controle da régua de controle, use as setas da direita e da esquerda para mover os manipuladores da régua de controle',
	'sliderHandleLabel': 'Manipulador da régua de controle',
	'a11ySliderHandleLabel': 'Alça de régua de controle %{sliderValue}',
	'sliderInputLabel': 'valor',

	// Side bar
	'sidebarAdd': 'Incluir',
	'clearTextFilterValue': 'Limpar',
	'missingDataSetData': 'Os dados para este conjunto de dados não estão disponíveis. Atualize o conjunto de dados ou entre em contato com o administrador para acessar a origem.',

	// Toolbar
	'toolbarRegionLabel': 'Barra de ferramentas',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Família de fontes',
	'fontFamilyStyle': 'Estilo de fonte',
	'regularFontStyle': 'Regular',
	'fontSizeSelect': 'Tamanho de fonte',
	'fontColorSelect': 'Cor',
	'fontStyle': 'Estilo',
	'colorPickerTitle': 'Selecionando uma Cor',
	'bold': 'Negrito',
	'italic': 'Itálico',
	'underline': 'Sublinhado',
	'fontAlignment': 'Alinhamento',
	'justifyLeft': 'Alinhamento esquerdo',
	'justifyCenter': 'Alinhamento central',
	'justifyRight': 'Alinhamento direito',
	'insertOrderedList': 'Lista Ordenada',
	'insertUnorderedList': 'Lista Não Ordenada',
	'fontColorPicker': 'Selecionador de Cores',
	'textWrap': 'Texto de sobreposição',
	'restore': 'Restaurar padrões',
	'textAutoFontSize': 'Automático',
	'textDefaultFontSize': 'Padrão',
	'textItemTitle': 'Título',
	'textLabelShadow': 'Sombra de etiqueta',
	'textContrastLabelColor':'Cor de contraste',
	'toggleOn': 'Ligar',
	'toggleOff': 'Desligar',
	'contrastLabelColorInfo': 'Ajuste automático da cor da etiqueta para acessibilidade. Isso substitui a cor da fonte.',
	'labelShadowInfo':'Inclua sombra ao texto para acessibilidade.',
	'applyToAll':'Aplicar estilo a todos os eixos',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Número de resultados (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Percentual (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Opção de parte superior ou parte inferior',
	'topbottomOptionLabel': 'Mostrar',
	'searchByLabel': 'Por',
	'searchNoMatches': 'Nenhuma correspondência encontrada',
	'topbottomRankColumnLabel': 'Inclua uma classificação para a tabela',
	'topbottomNone': 'Nenhum',
	'topCount': 'Contagem superior',
	'topPercent': '% primeiros',
	'bottomCount': 'Contagem inferior',
	'bottomPercent': '% últimos',
	'searchColumn': 'Localize uma coluna',
	'searchColumnAriaLabel': 'Localize uma coluna. Digite o nome da coluna a ser procurada, em seguida, use a seta para baixo para localizar a coluna em uma lista',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Classificação (%{columnLabel})',
	'topbottomClearLabel': 'Reconfigurar',

	// Format
	'formatAuto': 'Automático',
	'formatConvertPercent': 'Porcentagem decimal Converter',
	'formatAbbreviate': 'Abbreviate',
	'formatUseGrouping': 'Usar separador de milhares',
	'dateStyle': 'Estilo de Data',
	'dateTimeStyle': 'Estilo de data/hora',
	'formatMissingValueCharactersInfo': 'Os caracteres de valores ausentes especificam os caracteres a serem exibidos quando o valor está ausente.',
	'currencySymbolLabel': 'Símbolo monetário',
	'customSymbolPlaceholder': 'Incluir um símbolo',
	'customSymbolLabelInfo': 'Especifica um ou mais caracteres a serem usados como um símbolo customizado. Este símbolo precederá o número e qualquer sinal.',
	'numberLabel': 'Rótulo de número',
	'numberPositionLabel': 'Posição do rótulo',
	'negativeSignPosition': 'Posição do sinal negativo',
	'negativeSign': 'Símbolo de sinal negativo',
	'numberLabelInfo': 'Especifica um rótulo para o número formatado e colocado como prefixo ou sufixo, dependendo da posição do rótulo.',
	'nullValueDefault': '<padrão>',
	'nullValueContent': '(sem valor)',
	'default': 'Padrão',
	'beginning': 'Início',
	'end': 'Término',
	'formatLabel': 'Selecione um formato',

	// More data indicator
	'moreDataIndicator': 'Seus dados foram recortados em %{threshold} itens. Aplique um filtro para mostrar menos.',

	// Expanded View / Focus mode
	'evCollapse': 'Reduzir',
	'duplicate': 'Duplicado',
	'copyOf': 'Cópia do %{name}',
	'unableToDuplicateBoard': 'Não é possível duplicar "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Não podemos carregar os objetos.',

	// Custom widgets
	'customWidget': 'Widget customizado',

	// Auto group
	'group': 'Agrupar',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Fio',
	'textFontFamilySubClassThin': 'Fina',
	'textFontFamilySubClassThinItalic': 'Itálico Fino',
	'textFontFamilySubClassExtraLight': 'Extra Claro',
	'textFontFamilySubClassExtraLightItalic': 'Itálico Extra Claro',
	'textFontFamilySubClassLight': 'Claro',
	'textFontFamilySubClassLightItalic': 'Itálico Claro',
	'textFontFamilySubClassRegular': 'Regular',
	'textFontFamilySubClassRegularItalic': 'Itálico Regular',
	'textFontFamilySubClassItalic': 'Itálico',
	'textFontFamilySubClassMedium': 'Média',
	'textFontFamilySubClassMediumItalic': 'Itálico Médio',
	'textFontFamilySubClassHeavy': 'Pesado',
	'textFontFamilySubClassHeavyItalic': 'Pesado Itálico',
	'textFontFamilySubClassDemiBold': 'Negrito Médio',
	'textFontFamilySubClassDemiBoldItalic': 'Negrito Médio Itálico',
	'textFontFamilySubClassBold': 'Negrito',
	'textFontFamilySubClassBoldItalic': 'Negrito Itálico',
	'textFontFamilySubClassExtraBold': 'Negrito Extra',
	'textFontFamilySubClassExtraBoldItalic': 'Extra Negrito Itálico',
	'textFontFamilySubClassBlack': 'Preto',
	'textFontFamilySubClassBlackItalic': 'Preto Itálico',
	'textFontFamilySubClassStencil': 'Estêncil',
	// END: Remove FontFamilySubClass
});
